import React from 'react';

import { ButtonProps } from './types';
import * as S from './styles';

const Button = ({ hidden, onClick }: ButtonProps) => (
  <S.Wrapper onClick={onClick} hidden={hidden}>
    <S.Icon />
    <S.Label>Ajuda</S.Label>
  </S.Wrapper>
);

export default Button;
